
import {httpservice} from '../services';
import {constants} from '../constant/constant';
import {SOFTWARE} from "../constant/actionTypes";

export default id => dispatch => {
    dispatch({
        payload: [],
        type: SOFTWARE.PLATFORMS.INITIATE
    });

    return httpservice()
        .get(`${constants.API.SOFTWARE_PLATFORM}/${id}`)
        .then(response => {
            dispatch({
                payload: response.data.response,
                type: SOFTWARE.PLATFORMS.SUCCESS
            });
            return response.data.response;
        })
        .catch(function (error) {
            dispatch({
                payload: error,
                type: SOFTWARE.PLATFORMS.ERROR
            });
        });
};
